
/* @ngInject */
export default function modalScrollToTop(DirectiveService, $document, $timeout) {
    return {
        replace: true,
        restrict: 'A',
        scope: {
            scroll: '=',
        },
        link(scope, element) {
            DirectiveService.subscribe((msg) => {
                const msgSplit = msg.split(' ');
                if (msgSplit.length === 1 && msg === 'scroll') {
                    element.parent()[0].scrollTop = 0;
                } else if (msgSplit.length === 2 && msgSplit[0] === 'scroll') {
                    $timeout(() => {
                        console.log('$document[0].getElementById(msgSplit[1]).offsetTop', $document[0].getElementById(msgSplit[1]).offsetTop);
                        element.parent()[0].scrollTop = $document[0].getElementById(msgSplit[1]).offsetTop + 150;
                    });
                }
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/modalScrollToTop.directive.js